import FeatureGates from '@atlaskit/feature-gate-js-client';

// ALL FEATURE GATES SHOULD BE CALLBACKS
// CHECK IF USER IS LOGGED IN - if not, do not check for the feature gate

/**
 * UPP-UI-FEATURE-GATE-TEST
 * @link https://switcheroo.atlassian.com/ui/gates/ab5c3a4c-7985-4532-bd93-cb0ae3160a25/key/upp-ui-feature-gate-test
 * @description This feature gate is used to test the feature gate functionality in UPP UI
 * @returns true if the user should see the feature
 */
export const uppUiFeatureGateTestIsActive = (): boolean => FeatureGates.checkGate('upp-ui-feature-gate-test') ?? false;

/**
 * PRODUCT-ID-TO-NODE-ID-CHANGE
 * @link https://switcheroo.atlassian.com/ui/gates/02faeae7-dda3-4d18-9ab7-bbbbfc795ce2/key/product-id-to-node-id-change
 * @description This feature gate is used to test the feature gate functionality in UPP UI
 * @returns true if the user should see the feature
 */
export const productIdToNodeIdChangeIsActive = (): boolean => {
  if (process.env.REACT_APP_USE_MOCK_NETWORK_HANDLER === 'true') {
    return true;
  }

  return FeatureGates.checkGate('product-id-to-node-id-change') ?? false;
};

/**
 * Account Switcher
 * @link https://switcheroo.atlassian.com/ui/gates/7273b874-7130-439f-9f4e-c5c26b9fedca/key/community-account-switcher
 */
export const accountSwitcherIsActive = () => FeatureGates.checkGate('community-account-switcher') ?? false;

/**
 * Forums V2
 * @link https://switcheroo.atlassian.com/ui/gates/81652019-f9a1-4a71-bc2c-3dd5bd60fbd5/key/smart-community
 * @description This feature gate controls the forums v2 feature
 * @returns true if the user should see the forums v2 feature
 */
export const forumsV2IsActive = (): boolean => FeatureGates.checkGate('smart-community') ?? false;
// using for local development
// export const forumsV2IsActive = (): boolean => t

/**
 * New Navigation
 * @link https://switcheroo.atlassian.com/ui/gates/9912bd84-cf3a-4586-88b2-e61641977351/key/community_new_top_navigation
 * @description This feature gate controls the new navigation feature
 * @returns true if the user should see the new navigation feature
 */
export const newNavigationIsActive = (): boolean => FeatureGates.checkGate('community_new_top_navigation') ?? false;

/**
 * Champions Auth Signup
 * @link https://switcheroo.atlassian.com/ui/gates/40e0ce8b-3e3a-42e3-8415-c23c7f1938ab/key/community-champions-auth-signup
 * @description This feature gate controls access to the new auth-gated Champions signup flow.
 * When enabled, users will be directed to the internal /champions/apply page (requires authentication).
 * When disabled, users will be directed to the external Salesforce signup page.
 * @returns true if the user should see the new auth-gated signup flow
 */
export const championsAuthSignupIsActive = (): boolean =>
  FeatureGates.checkGate('community-champions-auth-signup') ?? false;

/**
 * Community App Updates
 * @link https://switcheroo.atlassian.com/ui/gates/e721eb2d-646b-4905-a21d-9060f599cb3a/key/community-app-updates
 * @description This feature gate controls the community app updates feature
 * @returns true if the user should see the community app updates feature
 */
export const communityAppUpdatesIsActive = (): boolean => FeatureGates.checkGate('community-app-updates') ?? false;
